// src/components/songEdit/hooks/useComposerSearch.ts
import { useState, useEffect } from 'react';
import { SearchResult } from '../types/composerTypes';
import { composerService } from '../../../services/composerService';
import { useDebounce } from './useDebounce';

export const useComposerSearch = (type: 'composer' | 'lyricist') => {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const performSearch = async () => {
      if (!debouncedSearchTerm || debouncedSearchTerm.length < 2) {
        setResults([]);
        setShowResults(false);
        return;
      }

      setIsLoading(true);
      try {
        console.log('Performing search for:', { debouncedSearchTerm, type }); // Debug log
        const searchResults = await composerService.searchComposers(debouncedSearchTerm, type);
        console.log('Search results:', searchResults); // Debug log
        setResults(searchResults);
        setShowResults(searchResults.length > 0);
      } catch (error) {
        console.error(`Error searching ${type}s:`, error);
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    };

    performSearch();
  }, [debouncedSearchTerm, type]);

  const handleSearch = (term: string) => {
    console.log('Search term changed:', term); // Debug log
    setSearchTerm(term);
  };

  return {
    results,
    isLoading,
    showResults,
    setShowResults,
    handleSearch
  };
};